// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2IEzo","header":"MergedInvoice_header__1YWs7"};